const DEEP_LINK_DOMAIN = process.env.REACT_APP_DEEP_LINK_DOMAIN;

export const createDeepLinkUrl = (appPath) => {
    if (DEEP_LINK_DOMAIN) {
        return `https://${DEEP_LINK_DOMAIN}${appPath}`;
    }
    return `${window.location.origin}${appPath}`;
};
